var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "button-wrap"
  }, [_c('div', {
    staticClass: "next",
    class: {
      mb: _vm.mb,
      has: _vm.has,
      cover: _vm.cover
    },
    on: {
      "click": function click($event) {
        return _vm.next();
      }
    }
  }, [_vm._v(_vm._s(_vm.txt))])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };